//tasks.ts

import { SeedLot } from "./seed";
import { CropTask, PackageTask, HarvestTask, SoakTask, SowTask } from "./task";
import { GrowerUser } from "./grower-user";

export type TaskType =
  | "soak"
  | "sow"
  | "blackout"
  | "uncover"
  | "harvest"
  | "package";

export interface TaskSeedLot {
  id: number;
  seedLotId: number;
  seedLot?: SeedLot;
}

export interface TaskPkgLot {
  id: number;
  pkgLotId: number;
}

export interface CompletedTask {
  id: number;
  date: string;
  dateActual?: string | null;
  itemId: number;
  type: TaskType;
  seedLots?: TaskSeedLot[];
  pkgLots?: TaskPkgLot[];
  completedBy?: string;
  notes?: string;
  traysNeeded?: number;
  traysBuffer?: number;
  traysExpected?: number;
  traysActual?: number;
  yieldExpected?: number;
  yieldActual?: number;
  bufferExpected?: number;
  harvestDate?: string;
  harvestKind?: "cut" | "live";
  cropName?: string;
  cropNotes?: string;
  cropExpectedYield?: number;
  cropSowingRate?: number;
  cropBufferPercentage?: number;
  seedName?: string;
  seedVariety?: string;
  seedNotes?: string;
  packagedProductName?: string;
  packagedProductSize?: string;
  packagedProductWeight?: number;
  packagedQuantityExpected?: number;
  packagedQuantityActual?: number;
  batchNumber?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface Tasks {
  date: string;
  soak: SoakTask[];
  sow: SowTask[];
  uncover: CropTask[];
  blackout: CropTask[];
  harvest: HarvestTask[];
  package: PackageTask[];
}

export interface TasksData {
  users: GrowerUser[];
  tasksForRange: Tasks[];
  lastCompletedBy?: string | null;
}

export const sameHarvestKey = (
  a: { cropId: number; harvestDate: string; harvestKind?: "cut" | "live" },
  b: { cropId: number; harvestDate: string; harvestKind?: "cut" | "live" },
) =>
  a.cropId === b.cropId &&
  a.harvestDate === b.harvestDate &&
  (a.harvestKind ?? "cut") === (b.harvestKind ?? "cut");
